import goalSales from './goalSales';
import goalSalesPeriod from './goalSalesPeriod';
import goalRevenues from './goalRevenues';
import wallet from './wallet';
import walletInfo from './walletInfo';
import commission from './commission';
import nonPayment from './nonPayment';
import collection from './collection';

export default {
	goalSales,
	goalSalesPeriod,
	goalRevenues,
	wallet,
	walletInfo,
	commission,
	nonPayment,
	collection,
};
